import { Modal, ModalBody, ModalFooter, Box, Autocomplete, Button, Textarea } from '@coolblue-development/freddy';
import { useState } from 'react';

interface TransferEmailModalProps {
  open: boolean;
  onClose: () => void;
  onTransfer: (destination: string, note: string) => void;
}

const NOTE_MAX_LENGTH = 1500;

const AUTOCOMPLETE_TRANSLATIONS = {
  labelChipsCollapsed: '',
  labelLoading: 'Loading...',
  labelNoOptions: 'No queues found',
  labelSelectAll: 'Select all',
  ariaLabelOpenDropdown: 'Open dropdown',
  ariaLabelCloseDropdown: 'Close dropdown',
  ariaLabelRemoveChip: 'Remove',
  ariaLabelRemoveAllChips: 'Remove all'
};

const TransferEmailModal = ({ open, onClose, onTransfer }: TransferEmailModalProps): JSX.Element => {
  const [destination, setDestination] = useState<string | null>(null);
  const [note, setNote] = useState('');

  const handleClose = (): void => {
    setDestination(null);
    setNote('');
    onClose();
  };

  const handleTransfer = (): void => {
    if (!destination) return;
    onTransfer(destination, note);
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title="Transfer email"
      size="large"
      translations={{ ariaLabelClose: 'Close' }}
      body={
        <ModalBody>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Autocomplete<string>
              options={[]}
              value={destination}
              onChange={(value: string | null) => setDestination(value)}
              getOptionLabel={(option: string | Record<string, unknown>) => (typeof option === 'string' ? option : '')}
              label="Transfer to queue"
              placeholder="Select a queue"
              translations={AUTOCOMPLETE_TRANSLATIONS}
            />
            <Textarea
              label="Comment (optional)"
              value={note}
              onChange={e => setNote(e.target.value.slice(0, NOTE_MAX_LENGTH))}
              helperText={`${note.length}/${NOTE_MAX_LENGTH}`}
              sx={{ minHeight: '160px' }}
            />
          </Box>
        </ModalBody>
      }
      footer={
        <ModalFooter>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
            <Button onClick={handleClose} variant="secondary">
              Cancel
            </Button>
            <Button onClick={handleTransfer} disabled={!destination} variant="primary">
              Transfer email
            </Button>
          </Box>
        </ModalFooter>
      }
    />
  );
};

export default TransferEmailModal;
